<div class="container-md pb-4 p-md-0">
  <div class="row g-4">
    <div class="col col-12">
      <ts-asset-card
        header="{{ 'line_to_transfer' | translate }}"
        [asset]="shopping_cart && shopping_cart.existing_asset"
        [asset_fields]="['plan', 'plan_features', 'add_on_features']"
      />
    </div>

    <div class="col col-12">
      <form [formGroup]="transfer_details_form">
        <div class="card shadow-sm">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h4 class="mb-3">{{ 'transfer_details' | translate }}</h4>

                <div *ngIf="!restrict_change_carrier" class="col col-12 mb-3">
                  <label class="form-label" [ngClass]="{ required: true }">
                    {{ 'change_current_carrier' | translate }}
                  </label>

                  <div class="form-check">
                    <input
                      type="radio"
                      id="KeepCarrier"
                      class="form-check-input"
                      formControlName="keep_existing_carrier"
                      [value]="'Yes'"
                    />
                    <label class="form-check-label" for="KeepCarrier">
                      {{ 'keep_carrier' | translate }}
                    </label>
                  </div>

                  <div class="form-check">
                    <input
                      type="radio"
                      id="switchCarrier"
                      class="form-check-input"
                      formControlName="keep_existing_carrier"
                      [value]="'No'"
                    />
                    <label class="form-check-label" for="switchCarrier">
                      {{ 'switch_carrier' | translate }}
                    </label>
                  </div>
                </div>
                <div class="col col-12 mb-3">
                  <label class="form-label" for="PersonalEmail" [ngClass]="{ required: true }">
                    {{ 'personal_email' | translate }}
                  </label>

                  <input
                    type="email"
                    id="PersonalEmail"
                    class="form-control"
                    [class.is-invalid]="
                      created_for_personal_email?.invalid &&
                      (created_for_personal_email?.dirty || created_for_personal_email?.touched)
                    "
                    formControlName="created_for_personal_email"
                    [required]="true"
                  />
                  <div
                    *ngIf="
                      created_for_personal_email?.invalid &&
                      (created_for_personal_email?.dirty || created_for_personal_email?.touched)
                    "
                    class="invalid-feedback"
                  >
                    <div *ngIf="created_for_personal_email?.errors?.['required']">
                      {{ 'personal_email_required' | translate }}
                    </div>
                    <div *ngIf="created_for_personal_email?.errors?.['email']">
                      {{ 'personal_email_invalid' | translate }}
                    </div>
                  </div>
                </div>
                <div class="col col-12 mb-3">
                  <label for="TransferNotes" class="form-label">
                    {{ 'transfer_notes' | translate }}
                  </label>

                  <textarea
                    id="TransferNotes"
                    class="form-control"
                    formControlName="transfer_notes"
                    restrict-input="no_empty_space"
                  ></textarea>
                  <div class="form-text">
                    {{ 'transfer_note_hint' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ts-price-summary
            [hide_price_content]="false"
            [button_status]="!disable_continue_btn"
            [navigate_page]="navigate_page"
            [shopping_cart]="shopping_cart"
            [refresh_summary]="refresh_summary.asObservable()"
            (updateCostSummary)="getShoppingCartData($event)"
            (onContinueSuccess)="onContinueSuccess($event)"
          />
        </div>
      </form>
    </div>
  </div>
</div>
